import APP_CONST from '../../constants';
import LogoutPage from './logout';

export default {
    name: 'logout',
    url: '/logout?{client}{app}',
    component: LogoutPage,
    layout: APP_CONST.LAYOUT_PARTIAL,
    skipTokenRefresh: true,
};